import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { CatalogItem } from '@/types/learning/learning-catalog';
import { useSavedLearnings, useUpdateSavedLearnings } from '@/pages/user/MyLearning/store';
import { SharedSnackbarContext } from '@/component/SharedSnackbar/SharedSnackbar';
import { CourseId } from '@/administration/pages/Course/store/types';

type UseSavedMyLearningProps = (courseId?: CourseId) => {
  loading: boolean;
  handleSavedLearnings: () => void;
  isSaved: boolean;
};

export const useSaveCourse: UseSavedMyLearningProps = (courseId) => {
  const item: CatalogItem = {
    id: Number(courseId),
    entity: 'learning',
  };
  const { t } = useTranslation('catalog');
  const { savedLearnings, loading } = useSavedLearnings();
  const { addSavedLearnings, removeSavedLearnings } = useUpdateSavedLearnings();
  const { openSnackbar } = useContext(SharedSnackbarContext);
  const isSaved = Boolean(savedLearnings.meta?.find((l) => l.id === item.id && l.entity === item.entity));

  const handleSavedLearnings = async () => {
    if (isSaved) {
      await removeSavedLearnings(savedLearnings, item);
      openSnackbar({ message: t('course-remove'), isDismissive: true });
    } else {
      await addSavedLearnings(savedLearnings, item);
      openSnackbar({ message: t('course-add'), isDismissive: true });
    }
  };

  return {
    loading,
    handleSavedLearnings,
    isSaved,
  };
};
